import { postJSON } from 'common/services/api'
import {
  INSTANCES_UPDATE_QUERY_KEY,
  INSTANCES_UPDATE_URL,
  REVISIONS_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseInstancesUpdateReturn = {
  updateEvents?: (values: UpdateEventsPayload) => Promise<unknown>
  isLoadingUpdateEvents?: boolean
}

type UpdateEventsPayload = {
  patternId?: string
  updateOption: string
}

const useInstancesUpdate = (): UseInstancesUpdateReturn => {
  const queryClient = useQueryClient()

  // Update events

  const updateEventsFunction = async (
    values: UpdateEventsPayload
  ): Promise<unknown> => {
    return postJSON({
      url: `${INSTANCES_UPDATE_URL}`,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const {
    mutateAsync: updateEventsMutation,
    isLoading: isLoadingUpdateEvents,
  } = useMutation<unknown, unknown, UpdateEventsPayload, unknown>(
    [INSTANCES_UPDATE_QUERY_KEY],
    updateEventsFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
      },
    }
  )

  const handleUpdateEvents = async (values: UpdateEventsPayload) => {
    try {
      const result = await updateEventsMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    updateEvents: handleUpdateEvents,
    isLoadingUpdateEvents,
  }
}

export default useInstancesUpdate
